module.exports = __webpack_public_path__ + "static/media/No-select-icon.a6e3904c.svg";